import { useState } from "react";

export default function DonationSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText("79420199215");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = "79420199215";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <section id="donation" className="py-12 md:py-20 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-10">
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Nanum Myeongjo', serif" }}
          >
            [우리가 지켜낼 대한민국]
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-amber-200/60 overflow-hidden">

          {/* 1. 선언문 */}
          <div className="px-6 md:px-10 py-7 border-b border-amber-100 bg-amber-50/50">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-6 h-6 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-double-quotes-l text-amber-400 text-xl"></i>
              </div>
              <div className="space-y-3">
                <p className="text-sm text-gray-700 leading-relaxed">
                  선조들의 희생과 기도로 세워진 이 땅의 자유는 우리가 누리는 당연한 권리이자, 동시에 반드시 지켜내야 할 거룩한 유산입니다.
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  우리는 이 소중한 자유의 가치가 훼손되지 않도록, 다음 세대에게 온전한 대한민국을 물려주기 위해 당당히 나설 것입니다. 무너진 법치의 토대를 다시 세우고, 투명하고 공명한 선거를 통해 자유 대한민국의 기틀을 수호해야 합니다.
                </p>
              </div>
            </div>
            <p className="text-center text-sm md:text-base font-semibold text-amber-700 mt-4 leading-relaxed">
              자유를 향한 청년들의 용기 있는 첫걸음,<br />
              그 위대한 여정에 여러분의 마음을 보태주십시오.
            </p>
          </div>

          {/* 2. 함께하기 */}
          <div className="px-6 md:px-10 py-7 border-b border-gray-100">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-group-line text-gray-500 text-base"></i>
              </div>
              <p className="text-sm font-bold text-gray-800">소식을 듣고 함께하기</p>
            </div>
            <div className="flex flex-row items-center justify-center gap-3 md:gap-5">
              {/* 텔레그램 */}
              <a
                href="https://t.me/+1WdQdYGXQFU2NmE1"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-sky-50 px-5 py-3 rounded-xl border border-sky-200 hover:bg-sky-100 transition-colors cursor-pointer flex-1 md:flex-none"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-sky-500 rounded-full shadow-sm shrink-0">
                  <i className="ri-telegram-fill text-lg text-white"></i>
                </div>
                <div className="text-left">
                  <div className="text-[10px] text-sky-600 font-medium">텔레그램</div>
                  <div className="text-xs font-bold text-gray-900">공지채널</div>
                </div>
              </a>

              {/* 카카오톡 */}
              <a
                href="https://open.kakao.com/o/gE2hVphi"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-yellow-50 px-5 py-3 rounded-xl border border-yellow-300 hover:bg-yellow-100 transition-colors cursor-pointer flex-1 md:flex-none"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-yellow-400 rounded-full shadow-sm shrink-0">
                  <i className="ri-kakao-talk-fill text-lg text-gray-900"></i>
                </div>
                <div className="text-left">
                  <div className="text-[10px] text-yellow-700 font-medium">카카오톡</div>
                  <div className="text-xs font-bold text-gray-900">소통채널</div>
                </div>
              </a>
            </div>
          </div>

          {/* 3. 후원계좌 */}
          <div className="px-6 md:px-10 py-7">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bank-card-line text-gray-500 text-base"></i>
              </div>
              <p className="text-sm font-bold text-gray-800">후원계좌</p>
            </div>
            <div className="bg-amber-50 border border-amber-200 rounded-xl px-5 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
                <span className="font-mono text-base md:text-lg font-bold text-gray-900">
                  카카오뱅크 794-2019-9215
                </span>
                <span className="hidden md:block w-px h-5 bg-amber-300"></span>
                <span className="text-sm text-gray-600 font-medium">예금주: 이ㅇ세</span>
              </div>
              <button
                onClick={handleCopy}
                className="flex items-center gap-1.5 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95 shrink-0"
              >
                <i className={`${copied ? "ri-check-line" : "ri-file-copy-line"} text-sm`}></i>
                {copied ? "복사 완료!" : "계좌번호 복사"}
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-2 text-center">웹사이트 운영 · 광고비 후원</p>
          </div>

        </div>
      </div>

      {/* 복사 완료 토스트 */}
      <div
        className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
          copied ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <div className="flex items-center gap-2 bg-gray-900 text-white px-5 py-3 rounded-xl shadow-xl">
          <i className="ri-check-double-line text-lg text-green-400"></i>
          <span className="text-sm font-medium">계좌번호가 복사되었습니다</span>
        </div>
      </div>
    </section>
  );
}
